import Swiper from 'swiper/js/swiper.min';
import Clamp from 'clamp-js';
import UAParser from 'ua-parser-js';
import MediaQuery from '../lib/MediaQuery';

export default function v1RecommendationTopCarousel() {
  if (!document.querySelectorAll('.v1-recommendationTopCarousel__slide')) {
    return;
  }

  // バレットに常時`tabindex="-1"`を指定する。
  function cancelBulletFocus() {
    setTimeout(() => {
      const bullet = document.querySelectorAll('.swiper-pagination-bullet');
      bullet.forEach(item => {
        item.setAttribute('tabindex', '-1');
      });
    }, 0);
  }

  // 一時停止ボタンフォーカス時に、ランキングが表示される位置までスクロールする
  function focusOnToggleStop() {
    const focusElm = document.getElementById('v1-recommendationTopCarousel__toggleButton');
    if (!focusElm) {
      return;
    }
    window.addEventListener('keyup', e => {
      const isTab = e.key === 'Tab';
      const isFocus = document.activeElement === focusElm;
      if (isTab && isFocus) {
        const windowOffset = window.pageYOffset;
        const carouselTop = document
          .getElementsByClassName('v1-recommendationTopCarousel')[0]
          .getBoundingClientRect().top;
        const offset =
          Math.sign(carouselTop) === -1 ? windowOffset + carouselTop - 70 : windowOffset;
        window.scrollTo(0, offset);
      }
    });
  }
  focusOnToggleStop();

  const headings = document.getElementsByClassName('v1-recommendationTopRank__heading');
  function addClamp(bool) {
    if (headings) {
      const isPc = bool;
      const parser = new UAParser();
      const isIE = parser.getBrowser().name === 'IE';
      const clampSettings = {
        // IEでは行数が1つ減ってしまう
        headings: isIE ? 4 : 3,
      };

      if (isPc) {
        Array.from(headings).forEach(heading => {
          Clamp(heading, { clamp: clampSettings.headings });
        });
      } else {
        Array.from(headings).forEach(heading => {
          // 省略されない数値に設定する
          Clamp(heading, { clamp: 99 });
        });
      }
    }
  }

  let mySwiper;

  const createSwiper = () => {
    mySwiper = new Swiper('.v1-recommendationTopCarousel__container', { // eslint-disable-line
      speed: 1000, // スライド間の遷移時間（ミリ秒）
      effect: 'fade', // 'slide', 'fade', 'cube', 'coverflow' or 'flip'
      spaceBetween: 0, // スライド間の距離（ピクセル）。
      slidesPerView: 1, // ビューあたりのスライド数（スライドのコンテナに同時に表示されるスライド）。
      loop: true,
      // autoHeight: true,

      // Navigation http://idangero.us/swiper/api/#navigation
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Pagination http://idangero.us/swiper/api/#paginationn
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets', // "bullets", "fraction", "progressbar" or "custom"
        clickable: true, // クリック可能か（`bullets`のみ指定可能）
      },
      // http://idangero.us/swiper/api/#lazy
      lazy: {
        loadPrevNext: true,
      },
      // Autoplay http://idangero.us/swiper/api/#autoplay
      autoplay: {
        delay: 3000,
      },

      on: {
        init() {
          // 同じ要素にアクセスさせないため、複製した要素はフォーカス不可にする。
          const duplicate = document.getElementsByClassName('swiper-slide-duplicate');
          const slide = document.getElementsByClassName('v1-recommendationTopRank');
          duplicate.forEach(item => {
            item.setAttribute('tabindex', '-1');
            const elements = item.querySelectorAll(
              'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"]',
            );
            elements.forEach(element => {
              element.setAttribute('tabindex', '-1');
            });
          });
          slide.forEach(item => {
            item.setAttribute('tabindex', '-1');
          });
          cancelBulletFocus();
        },
        // アクティブなスライドだけフォーカス可能にする。
        slideChange() {
          const slides = document.getElementsByClassName('v1-recommendationTopCarousel__slide');
          const index = this.activeIndex;
          slides.forEach(slide => {
            slide.querySelectorAll('.v1-recommendationTopRank')[0].setAttribute('tabindex', '-1');
          });
          slides[index].querySelector('.v1-recommendationTopRank').setAttribute('tabindex', '0');
          cancelBulletFocus();
        },
      },
    });
  };

  /**
   * ボタンをクリックするとカルーセルの停止・開始を切り替わる。
   */
  const button = document.getElementById('v1-recommendationTopCarousel__toggleButton');
  function toggle(e) {
    if (!button) {
      return;
    }

    e.preventDefault();

    const isAutoplay = !!mySwiper.autoplay.running;

    if (isAutoplay) {
      mySwiper.autoplay.stop();
      button.classList.add('-stop');
      button.classList.remove('-play');
      return;
    }

    mySwiper.autoplay.start();
    button.classList.add('-play');
    button.classList.remove('-stop');
  }

  function initializeAutoplayClass() {
    button.classList.add('-play');
    button.classList.remove('-stop');
  }

  window.addEventListener('load', () => {
    MediaQuery.matches('lg', matches => {
      if (matches && button) {
        addClamp(true);
        createSwiper();
        button.addEventListener('click', toggle);
        initializeAutoplayClass();
      }

      if (!matches && button) {
        addClamp(false);
        if (mySwiper) {
          mySwiper.destroy(false, true);
        }

        button.removeEventListener('click', toggle, false);
      }
    });
  });
}
